import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { ReactiveFormsModule, FormArray, FormGroup, FormGroupDirective } from '@angular/forms';
import { DynamicAccordionFormComponent } from '../dynamic-accordion-form/dynamic-accordion-form.component';
import { DynamicFormService } from '../../services/dynamic-form.service';
import { FIELD_CONTROL, FIELD_CONFIG } from './field-tokens';

@Component({
  selector: 'app-field-accordion-array',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ReactiveFormsModule, DynamicAccordionFormComponent],
  template: `
    <app-dynamic-accordion-form
      [formArray]="formArray"
      [entityName]="config.arrayConfig?.entityName || 'Item'"
      [fields]="config.arrayConfig?.accordionFields || config.arrayConfig?.dialogFields || []"
      [requiredFields]="config.arrayConfig?.itemRequiredFields || []"
      (addItem)="onAddItem()"
      (deleteItem)="onDeleteItem($event)" />
  `
})
export class AccordionArrayFieldComponent {
  readonly config   = inject(FIELD_CONFIG);
  readonly control  = inject(FIELD_CONTROL);
  private readonly formService = inject(DynamicFormService);
  private readonly rootForm    = inject(FormGroupDirective);

  get formArray(): FormArray { return this.control as FormArray; }

  onAddItem(): void {
    const factory = this.config.arrayConfig?.factory;
    if (!factory) return;
    const validators = this.config.arrayConfig?.itemValidators || {};
    this.formArray.push(this.formService.buildItemGroup(factory(), validators));
    this.rootForm.control.markAsDirty();
  }

  onDeleteItem(index: number): void {
    this.formArray.removeAt(index);
    this.rootForm.control.markAsDirty();
  }
}
